import script from "./Default.vue?vue&type=script&setup=true&lang=ts"
export * from "./Default.vue?vue&type=script&setup=true&lang=ts"

import "./Default.vue?vue&type=style&index=0&id=17d00268&scoped=true&lang=css"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\CAXaAnQuang\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17d00268"]])

export default __exports__